import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import axios from 'axios'

import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Profile.vue'
import Admin from '../views/Admin.vue'
import SharesView from '../views/SharesView.vue'
import Setup from '../views/Setup.vue'
import ListDetailView from '../views/ListDetailView.vue'
import ListView from '../views/ListView.vue'

const routes = [
  {
    path: '/',
    redirect: '/lists'
  },
  {
    path: '/setup',
    name: 'Setup',
    component: Setup
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/shares',
    name: 'SharesView',
    component: SharesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/shared/:link_id',
    name: 'SharedView',
    component: ListDetailView,
    props: route => ({
      shared: true,
      link_id: route.params.link_id,
      hmac: route.query.hmac
    })
  },
  {
    path: '/lists',
    name: 'ListView',
    component: ListView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lists/:uuid',
    name: 'ListDetailView',
    component: ListDetailView,
    meta: { requiresAuth: true },
    props: route => ({
      shared: false,
      listId: route.params.uuid
    })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Check if setup is required
  try {
    const response = await axios.get('/api/setup/status')
    const setupRequired = response.data.setup_required
    
    if (setupRequired && to.name !== 'Setup') {
      next('/setup')
      return
    }
    
    if (!setupRequired && to.name === 'Setup') {
      next('/login')
      return
    }
  } catch (error) {
    // If we can't check setup status, continue with normal flow
    console.warn('Could not check setup status:', error)
  }
  
  // Allow print route for shared links without auth
  const isSharedPrint = to.name === 'PrintView' && to.query.link_id && to.query.hmac
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated && !isSharedPrint) {
    next('/login')
  } else if ((to.name === 'Login' || to.name === 'Register') && authStore.isAuthenticated) {
    next('/lists')
  } else if (to.meta.requiresAdmin && authStore.user?.role !== 'ADMIN') {
    next('/lists')
  } else {
    next()
  }
})

export default router